import callAPiBase from './base';

const numberOfMessagesApi = {
  list: ({
    params: {
      startDate,
      endDate,
    },
  }: {
    params: {
      startDate: number;
      endDate: number;
    };
  }) =>
    callAPiBase({
      endpoint: `/api/reports/attendants/messages?startDate=${startDate}&endDate=${endDate}`,
      method: 'POST',
      useToken: true,
    }),
};

export { numberOfMessagesApi };
export default numberOfMessagesApi;
